<div class="animated-card">
  <div class="card card_mc"></div>
  <div class="card card_visa"></div>

  @if ('card_mir' === animatedIconName) {
    <div class="card card_mir"></div>
  }
</div>